/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import type { IErrorResponse, ProductGroupInventories } from '@/types';

import { useQuery } from '@tanstack/react-query';

import { urls } from '@/statics';

const useProductGroupInventories = ({
  productGroupCodes,
  enabled = true,
}: {
  productGroupCodes: number[];
  enabled?: boolean;
}) =>
  useQuery<ProductGroupInventories, IErrorResponse>({
    queryKey: [
      `${urls.productGroupInventories}?product_group_codes=${productGroupCodes.join(',')}`,
    ],
    enabled,
  });

export default useProductGroupInventories;
